import React from 'react';
import Metatags from './meta-tags';
import Paths from '../../shared/components/paths';
import Countries from './countries';
import Breadcrumbs from './breadcrumbs';
import FooterLinks from './footer-links';
import FooterSearch from './footer-search';
import SemanticSearchToggle from '../../shared/components/semantic-search-toggle';
import ZAddButton from '../../z-button-add';

const OptimizationView = ({
  id,
  onCreateSection,
  onFooterSearch,
  scrollTargetEle,
  onTopSectionClick,
  title,
}) => (
  <>
    <Paths
      entityId={id}
      entityTitle={title}
      entityType="LandingPage"
      pathPrefix="l/"
    />
    <br/>
    <Metatags
      entityId={id}
    />
    <br/>
    <Countries
      entityId={id}
    />
    <br/>
    <Breadcrumbs
      entityId={id}
    />
    <SemanticSearchToggle
      entityId={id}
      entityType="landing_page"
    />
    <br/>
    <h3>SEO Footer Links</h3>
    <FooterSearch
      onFooterSearch={onFooterSearch}
    />
    <div style={{display: 'flex', flexDirection: 'row-reverse'}}>
      <ZAddButton onClick={onTopSectionClick}>Add Section</ZAddButton>
    </div>
    <br/>
    <FooterLinks
      entityId={id}
    />
    <div ref={scrollTargetEle}/>
    <br/>
    <div style={{display: 'flex', flexDirection: 'row-reverse'}}>
      <ZAddButton onClick={onCreateSection}>Add Section</ZAddButton>
    </div>
    <br/>
  </>

);

export default OptimizationView;
